import React, { useEffect, useState } from "react";
import useApi from "../../hooks/useApi";
import { useParams } from "react-router-dom";
import { LoadingComponent } from "usbc-web-react-library";
import { LoadingButton } from "usbc-web-react-library";
import CardContainer from "../Shared/Card/CardContainer";
import AnimatedCheck from "../Shared/Animation/AnimatedCheck";
import AnimatedExclamation from "../Shared/Animation/AnimatedExclamation";


function LeagueInvitationAcceptance() {
    const
        {
            fetchData: getRegisterationState,
            response: registrationState,
            loading: loadingRegistrationState
        } = useApi();

    const
        {
            fetchData: acceptLeagueInvitation,
            response: leagueInvitationAcceptanceResponse,
            loading: loadingLeagueInvitationAcceptance
        } = useApi();

    let { code } = useParams();
    const [message, setMessage] = useState(null);
    const [acceptClicked, setAcceptClicked] = useState(false);
    const [cancelClicked, setCancelClicked] = useState(false);
    useEffect(() => {
        getRegisterationState({ url: 'getinvitationstate/' + code })
    }, [])

    function onAcceptanceHandler() {
        acceptLeagueInvitation({
            url: 'acceptleagueinvitation',
            method: 'POST',
            body:
            {
                bowler:
                {
                    memberId: registrationState?.memberId
                },
                code: code
            }
        }).then((res) => {
            setAcceptClicked(true);
            setMessage(res.messages);
        })
    }
    return (
        <>{!acceptClicked && !cancelClicked &&
            <LoadingComponent isLoading={() => loadingRegistrationState === true} description='Loading your invitation'>
                {!registrationState?.validationMessage ?
                    <div className='custom-card mt-3' style={{ minHeight: '400px' }}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col w-100 fw-bold fs-5">
                                    {registrationState?.memberName} (Member Id {registrationState?.memberId}) has been added to the following USBC League:
                                </div>
                            </div>
                            <div className="row p-3">
                                <div className="col-11 ps-4">
                                    <p className="fs-6 fw-light">
                                        <span className="text-primary">{registrationState?.leagueSummary?.center?.name}</span> {registrationState?.leagueSummary?.center?.address}
                                    </p>
                                </div>
                            </div>
                            <div className="row p-3">
                                <div className="col-11 ps-4">
                                    <p className="fs-6 fw-light">
                                        <span className="fw-bold">{registrationState?.leagueSummary?.league?.name}</span><br />
                                        Starts: {registrationState?.leagueSummary?.league?.start} every {registrationState?.leagueSummary?.league?.dayOfWeek} at {registrationState?.leagueSummary?.league?.time} for {registrationState?.leagueSummary?.league?.duration} weeks
                                        <br />
                                        {registrationState?.leagueSummary?.league?.welcomeMessage}
                                    </p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col w-100 fw-bold fs-5">
                                    By accepting this league invitation, you are agreeing to share your information with the center.
                                </div>
                            </div>
                        </div>
                        <div className=" col d-flex justify-content-end pt-5">
                            <button type="button" className="btn btn-primary bowl-btn" onClick={() => setCancelClicked(true)} >Cancel</button>
                            <LoadingButton className="btn btn-primary pay-btn" onClick={onAcceptanceHandler} loading={loadingLeagueInvitationAcceptance}>
                                Accept
                            </LoadingButton>
                        </div>
                    </div>
                    :
                    <CardContainer title={"Invitation Not Granted"}>
                        <div className="row">
                            <div className="icon-box">
                                <div className={'finished-container-icon'}>
                                    <AnimatedExclamation />
                                </div>
                            </div>
                            <h4 className="text-center finished-header-text fw-normal">Invitation Not Granted!</h4>
                            <h5 className="text-center text-secondary">
                                {Array.isArray(registrationState?.validationMessage) ?
                                    registrationState?.validationMessage.join(", ")
                                    : registrationState?.validationMessage}
                            </h5>
                        </div>
                    </CardContainer>}

            </LoadingComponent>
        }

            {
                acceptClicked && !leagueInvitationAcceptanceResponse.messages ?
                    <LoadingComponent isLoading={() => loadingRegistrationState === true} description='Loading your invitation'>
                        <CardContainer title={"Invitation Granted"}>
                            <div className="row">
                                <div className="icon-box">
                                    <div className={'finished-container-icon'}>
                                        <AnimatedCheck />
                                    </div>
                                </div>
                                <h4 className="text-center finished-header-text fw-normal">Invitation Accepted!</h4>
                                <h5 className="text-center text-secondary">
                                    Great, You are opted-in into {registrationState?.leagueSummary?.league?.name} league for season: {registrationState?.leagueSummary?.league.season} at center: {registrationState?.leagueSummary?.center?.name}
                                </h5>
                            </div>
                        </CardContainer>
                    </LoadingComponent>
                    : ""
            }
            {
                acceptClicked && leagueInvitationAcceptanceResponse.messages ?
                    <CardContainer title={"Invitation Not Granted"}>
                        <div className="row">
                            <div className="icon-box">
                                <div className={'finished-container-icon'}>
                                    <AnimatedExclamation />
                                </div>
                            </div>
                            <h4 className="text-center finished-header-text fw-normal">Invitation Not Granted!</h4>
                            <h5 className="text-center text-secondary">
                                {Array.isArray(leagueInvitationAcceptanceResponse.messages) ?
                                    leagueInvitationAcceptanceResponse.messages.join(", ")
                                    : leagueInvitationAcceptanceResponse.messages}
                            </h5>
                        </div>
                    </CardContainer>
                    : ""
            }
            {
                cancelClicked ?
                    <CardContainer title={"Invitation Canceled"}>
                        <div className="row">
                            <div className="icon-box">
                                <div className={'finished-container-icon'}>
                                    <AnimatedExclamation />
                                </div>
                            </div>
                            <h4 className="text-center finished-header-text fw-normal">Invitation Canceled!</h4>
                            <h5 className="text-center text-secondary"> You can still grant the invitation by clicking the link again within 24 hours.
                            </h5>
                        </div>
                    </CardContainer>
                    : ""

            }
        </>

    )
}

export default LeagueInvitationAcceptance